<template>
  <div>
    <div class="comp_index_cont">
      <div v-for="item in comp_data.rows" @click="handleChooseComp(item[0],item[1])" class="comp_index_line">
        <div class="comp_index_line_txt">{{item[1]}}</div>
      </div>
    </div>
    <div class="mint-indexlist-nav"><!--右侧索引-->
      <ul class="mint-indexlist-navlist">
        <li class="mint-indexlist-navitem" :id="item" @touchend="right_index_touch_cancel"
            @touchstart="right_index_touch(item)" @touchmove="right_index_touch_move" v-for="item in abc">{{item}}</li>
      </ul>
    </div>
    <div class="mint-indexlist-navitem_toast">{{abc_choose}}</div>
  </div>
</template>
<script>
  export default {
    name: 'indexlist',
    data() {
      return{
        abc_choose: '',
        abc: [],
      }
    },
    mounted() {
        // 循环创建A - Z
        for(var i=0;i<this.comp_data.rows.length;i++){
          if(this.abc[this.abc.length - 1] != this.comp_data.rows[i][2].substring(0,1)){
            this.abc.push(this.comp_data.rows[i][2].substring(0,1));
          }
        }
    },
    props: ['comp_data'],
    methods: {
      handleChooseComp(code,name){
        this.$emit('handle_chooseComp_f',code,name);
      },
      right_index_touch(name){
        this.abc_choose = name;
        this.goToCorrectIndexComp(name);
        $('.mint-indexlist-navitem_toast').show();
      },
      right_index_touch_move(event){
        if (this.abc.length == 0)return;
        var fistindexY  = $('#' + this.abc[0]).offset().top;
        var singleIndexLength = $('.mint-indexlist-navlist').height() / this.abc.length;
        var index =  Math.round((event.touches[0].clientY - fistindexY)/singleIndexLength);  // 手指当前算出距离第一个右侧索引第一个元素到底有多少距离
        if(index > this.abc.length)return;  // 手指超出字母区域不显示
        this.abc_choose = this.abc[index];
        if (this.abc_choose){
          $('.mint-indexlist-navitem_toast').show();
          this.goToCorrectIndexComp(this.abc_choose);
        }else{  // 手指必须在字母区域才显示
          $('.mint-indexlist-navitem_toast').hide();
        }
      },
      right_index_touch_cancel(){
        $('.mint-indexlist-navitem_toast').hide();
      },
      goToCorrectIndexComp(name){
        var corrIndex;
        for(var index = 0;index< this.comp_data.rows.length;index++){
          var comp = this.comp_data.rows[index][2];
          if (comp.indexOf(name) == 0){
            corrIndex = index;
            break;
          }
        }
        var offsetTop = ($('.comp_index_cont').height()/this.comp_data.rows.length) * corrIndex;
        $('.second_choice_content').scrollTop(offsetTop);
      },
    }
  }
</script>
<style scoped>
  .comp_index_line{
    width: 100%;
    font-size: 0.2688rem;
    line-height: 0.8448rem;
    color: #333333;
    height: 0.8448rem;
    border-bottom: 0.0096rem solid rgb(245, 245, 245);
  }
  .comp_index_line_txt{
    float: left;
    display: inline;
    text-align: center;
    height: 100%;
  }
  .comp_index_cont{
    width: 90%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .mint-indexlist-navlist{
    padding: 0;
    list-style: none;
    margin: 0;
    max-height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .mint-indexlist-nav{
    position: absolute;
    top: 0.8448rem;
    bottom: 0;
    right: 0;
    background-color: #fff;
    border-left: 1px solid #ddd;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 0;
    max-height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-left: 20px;
  }
  .mint-indexlist-navitem{
    height: 0.31rem;
    padding: 1px 8px;
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    margin: 0;
    display: list-item;
    text-align: -webkit-match-parent;
  }
  .mint-indexlist-navitem_toast{
    display: none;
    z-index: 1000000000;
    position: fixed;
    color: #ffffff;
    background: #999999;
    top: 45%;
    left: 47%;
    border-radius: 5px;
    padding: 0.4rem;
    font-size: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// indexlist.vue?341df99c